





































































































































import { Component, Mixins, Watch } from "vue-property-decorator";
import BaseServiceMixin from "../mixins/base.service.mixin";
import { UserModel } from "../models/UserModel";
import UserService from "../services/user.service";
import eventBus from "../common/bus";
import UpsertUser from "@/components/UpsertUser.vue";
import { Role } from "@/common/enum";
import Shared from "../common/shared";
import DepartmentService from "../services/department.service";

@Component({
  components: {
    UpsertUser,
  },
})
export default class Home extends Mixins(BaseServiceMixin) {
  private users: UserModel[] = [];
  private invites: UserModel[] = [];
  private userService!: UserService;
  private departmentService!: DepartmentService;
  private user: UserModel = new UserModel();
  private invite: UserModel = new UserModel();
  private isModelActive = false;
  private role = Role;

  private get isZing(): boolean {
    return this.vuexStore.user ? this.vuexStore.user.isZing : false;
  }

  public created() {
    this.userService = new UserService(this.axiosInstance);
    this.departmentService = new DepartmentService(this.axiosInstance);
  }

  private async mounted() {
    await Promise.all([this.getUsers(), this.getInvites(), this.getDepartments()]);
  }

  @Watch("isModelActive")
  private onModelActivity() {
    if (!this.isModelActive) {
      this.user = new UserModel();
    }
  }

  private async getDepartments() {
    const departments = await this.departmentService.getDepartments();
    this.vuexStore.setDepartments(departments);
  }

  private async getUsers() {
    eventBus.$emit("loading", true);
    try {
      const users: UserModel[] = await this.userService.getUsers();
      this.users = users;
    } catch (error) {
      // Handle error
    } finally {
      eventBus.$emit("loading", false);
    }
  }

  private async getInvites() {
    eventBus.$emit("loading", true);
    try {
      const invites: UserModel[] = await this.userService.getInvites();
      this.invites = invites;
    } catch (error) {
      // Handle error
    } finally {
      eventBus.$emit("loading", false);
    }
  }

  private editUser(user: UserModel) {
    this.user = user;
    this.isModelActive = true;
  }

  private onDeleteInvite(invite: UserModel) {
    this.invite = invite;
    this.$buefy.dialog.confirm({
      title: "Delete Invite",
      message: `Are you sure you want to delete this invite?`,
      confirmText: "Delete",
      type: "is-danger",
      onConfirm: this.deleteInvite,
    });
  }

  private async deleteInvite() {
    eventBus.$emit("loading", true);
    try {
      await this.userService.deleteInvite(this.invite.id);
      await this.getInvites();
    } catch (error) {
      // Handle error
    } finally {
      eventBus.$emit("loading", false);
    }
  }

  private async onSaveUser(user: UserModel | null) {
    this.isModelActive = false;
    if (user) {
      await this.getUsers();
    } else {
      Shared.showToastMessage(Shared.messages.USER_INVITE_SUCCESSFUL, "is-success");
      await this.getInvites();
    }
  }

  private getDepartment(id: number): string {
    const department = this.vuexStore.departments ? this.vuexStore.departments.find((x) => x.id === id) : undefined;
    return department ? department.name : "-";
  }

  private async addToZendesk(id: string) {
    try {
      const user: UserModel = await this.userService.configureZendeskUser(id);
      if (user) {
        Shared.showToastMessage(Shared.messages.CONFIGURE_ZENDESK_USER, "is-success");
        await this.getUsers();
      }
    } catch (error) {
      Shared.showToastMessage(error.message, "is-danger");
    }
  }
}
